import { AccountDetailsStatusI } from "shared/lib/interfaces/account";
import {
  ACCOUNT_DISPOSITION_STATUSES,
  MEETING_OUTCOMES,
} from "shared/lib/constants/account";
import {
  ACCOUNT_DISPOSITION_STATUS_PILL_PARAMS,
  ACCOUNT_DISPOSITION_SUB_STATUS_PILL_PARAMS,
  ACCOUNT_DISPOSITION_SUB_STATUS_PILL_PARAMS_GLENX,
} from "shared/lib/constants/ui";
import { DISQUALIFY_DISPOSITION_LABELS } from "shared/lib/constants/dispositions";
import { createDisqualificationTooltipContent } from "shared/ui/account-details/disqualification-tooltip-content";

export const getAccountDispositionStatusParams = (
  accountStatus: AccountDetailsStatusI | undefined,
  isGlenXCampaign = false
) => {
  if (!accountStatus || accountStatus?.status === undefined) {
    return {
      label: "",
      style: "",
    };
  }

  if (accountStatus.status === "") {
    return {
      ...ACCOUNT_DISPOSITION_STATUS_PILL_PARAMS[
        ACCOUNT_DISPOSITION_STATUSES.COLD_LEAD
      ],
    };
  }

  const isDisqualified =
    accountStatus.status === ACCOUNT_DISPOSITION_STATUSES.DISQUALIFIED;

  if (
    accountStatus.status === ACCOUNT_DISPOSITION_STATUSES.FEEDBACK_RECEIVED &&
    accountStatus.meeting_status
  ) {
    const labelContainer = isGlenXCampaign
      ? ACCOUNT_DISPOSITION_SUB_STATUS_PILL_PARAMS_GLENX
      : ACCOUNT_DISPOSITION_SUB_STATUS_PILL_PARAMS;

    const labelData = { ...labelContainer[accountStatus.meeting_status] };

    if (
      accountStatus.meeting_status === MEETING_OUTCOMES.QUALIFIED &&
      !isGlenXCampaign &&
      (accountStatus.is_payout_pending || accountStatus.is_disputed)
    ) {
      labelData.label = "Meeting Shown" as typeof labelData.label;
    }

    return labelData;
  }

  return {
    ...ACCOUNT_DISPOSITION_STATUS_PILL_PARAMS[accountStatus.status],
    tooltip: isDisqualified
      ? createDisqualificationTooltipContent(
          accountStatus.dq_reason
            ? DISQUALIFY_DISPOSITION_LABELS[accountStatus.dq_reason]
            : null,
          accountStatus.dq_reason_notes
        )
      : undefined,
  };
};
